import { CodexSchema } from '@common/schemas/entities/codex.schema';
import { z } from 'zod';

/** DTO shape = raw Firestore document, inferred from commons CodexSchema */
export type CodexDTO = z.infer<typeof CodexSchema>;

/**
 * Codex Form schema.
 * Extends Common schema with UI-only fields like pendingFiles.
 */
export const CodexFormSchema = CodexSchema.omit({ audit: true }).extend({
  id: z.string().optional(), // Optional for new entities
  visualDescription: z.string().max(1500, "Visual description is too long (max 1500 characters)").optional(),
  pendingFiles: z.array(z.instanceof(File)).optional(),
}).passthrough();

export type CodexFormValues = z.infer<typeof CodexFormSchema>;
